import { Link } from "react-router-dom";
import { Pencil } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

// Small floating chip shown only to admins on the storefront so they know
// inline edit is available. Hover pencil icons appear on editable elements.
export default function AdminEditIndicator() {
  const { user } = useAuth();
  if (user?.role !== "admin") return null;
  return (
    <div
      className="hidden md:block fixed bottom-6 right-6 z-40 select-none"
      data-testid="admin-edit-indicator"
    >
      <Link
        to="/admin"
        className="group flex items-center gap-2.5 bg-ink text-ivory px-4 py-2.5 shadow-[0_10px_30px_-8px_rgba(0,0,0,0.4)] hover:bg-gold-deep transition-colors"
        title="You're in inline-edit mode. Hover images or text to edit them."
      >
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-gold opacity-70" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-gold" />
        </span>
        <Pencil size={12} strokeWidth={1.6} />
        <span className="overline text-[0.6rem]">Live edit · Admin</span>
      </Link>
    </div>
  );
}
